$(document).ready(function() {
    $('#get-access-to-the-courses-link').on('click', function(e) {
        e.preventDefault();
        $('#requestCourseBySchoolModal').show();

        $.ajax({
            url: $(e.target).attr('href'),
            method: 'GET',
        }).done(function(response) {
            $('#requestCourseBySchoolModalLoading').hide();
            $('#requestCourseBySchoolModal .modal-content').html(response);
        }).fail(function(jqXHR, textStatus, errorThrown) {
            $('#requestCourseBySchoolModalLoading').hide();
            console.error('AJAX Error:', textStatus, errorThrown);
        })
    });

    $(document).on('click', '.close-request-course-by-school-modal', function (e) {
        e.preventDefault();
        $('#requestCourseBySchoolModal').hide();
    });

    $(document).on('click', '.login-register__modal-overlay', function (e) {
        e.preventDefault();
        $('#requestCourseBySchoolModal').hide();
    });
});
